export const uiLinkBlock = {
    name: 'UI Link Block',
    description: 'Makes a whole block of UI clickable',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        url: {
            name: 'Url',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        block: {
            name: 'Block',
            type: 'Link',
            linkType: 'Entry',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiBlock', 'uiCaption'] }]
        },
        lift: {
            name: 'Lift',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        lighten: {
            name: 'Lighten',
            type: 'Boolean',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        }
    }
};
//# sourceMappingURL=uiLinkBlock.js.map